const TAB_ACTION = 'tab_selected' as const;

export const TAB_SELECTED_EVENTS = {
  WHATS_NEW: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'whats_new',
  },
  MY_PROFILE: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'my_profile',
  },
  UPGRADES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'upgrades',
  },
  ATTENTION: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'attention',
  },
  PATIENTS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'patients',
  },
  PATIENTS_HELP: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'patients_help',
  },
  ORDERS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'orders',
  },
  MANAGED_REPEATS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'managed_repeats',
  },
  WORKFLOW_DASHBOARD: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'workflow_dashboard',
  },
  SERVICES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'services',
  },
  SERVICE_DASHBOARD: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'service_dashboard',
  },
  CALENDAR: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'calendar',
  },
  BROADCASTING: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'broadcasting',
  },
  REVIEWS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'reviews',
  },
  BANNERS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'banners',
  },
  RESOURCES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'resources',
  },
  ADMIN_PHARMACIES: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'admin_pharmacies',
  },
  ADMIN_ONLINE_SHOP: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'admin_online_shop',
  },
  ADMIN_PAYMENTS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'admin_payments',
  },
  SMS_CAMPAIGNS: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'sms_campaigns',
  },
  SUPPORT_DASHBOARD: { action: TAB_ACTION, type: TAB_ACTION, tab: 'support_dashboard' },
  WEBSITE: {
    action: TAB_ACTION,
    type: TAB_ACTION,
    tab: 'plus-websites',
  },
} as const;

/**
 * Maps navigation item IDs to their corresponding tab tracking events.
 * Based on ukNavigationConfig.js actual navigation item IDs.
 */
export const NAV_ID_TO_TAB_EVENT = {
  'announcements': TAB_SELECTED_EVENTS.WHATS_NEW,
  'pro': TAB_SELECTED_EVENTS.UPGRADES,
  'overdue-orders': TAB_SELECTED_EVENTS.ATTENTION,
  'patients-component': TAB_SELECTED_EVENTS.PATIENTS,
  'patients-help': TAB_SELECTED_EVENTS.PATIENTS_HELP,
  'orders': TAB_SELECTED_EVENTS.ORDERS,
  'managed-repeats': TAB_SELECTED_EVENTS.MANAGED_REPEATS,
  'dashboard': TAB_SELECTED_EVENTS.WORKFLOW_DASHBOARD, // ID is 'dashboard', not 'workflow-dashboard'
  'services': TAB_SELECTED_EVENTS.SERVICES,
  'group-dashboard': TAB_SELECTED_EVENTS.SERVICE_DASHBOARD, // ID is 'group-dashboard', not 'service-dashboard'
  'calendar': TAB_SELECTED_EVENTS.CALENDAR,
  'broadcast': TAB_SELECTED_EVENTS.BROADCASTING, // ID is 'broadcast', not 'broadcasting'
  'reviews': TAB_SELECTED_EVENTS.REVIEWS,
  'banners': TAB_SELECTED_EVENTS.BANNERS,
  'in-app-banners': TAB_SELECTED_EVENTS.BANNERS,
  'resources': TAB_SELECTED_EVENTS.RESOURCES,
  'pharmacies': TAB_SELECTED_EVENTS.ADMIN_PHARMACIES, // ID is 'pharmacies', not 'admin-pharmacies'
  'online-shop': TAB_SELECTED_EVENTS.ADMIN_ONLINE_SHOP, // ID is 'online-shop', not 'admin-online-shop'
  'sms-campaigns': TAB_SELECTED_EVENTS.SMS_CAMPAIGNS,
  'plus-websites': TAB_SELECTED_EVENTS.WEBSITE,
  'support-dashboard': TAB_SELECTED_EVENTS.SUPPORT_DASHBOARD,
  // Note: 'admin-payments' tab does not exist in ukNavigationConfig.js
} as const;

